import { TextField } from "components/text-field";
import { UserWithNullableNames } from "core/types/index";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  user: UserWithNullableNames;
  validation: { field: string; message: string }[];
  onChangeUser: (x: string) => (x: ChangeEvent<HTMLInputElement>) => void;
};

const EditableName = ({ user, validation, onChangeUser }: Props) => {
  const firstNameValidation = validation.find((v) => v.field === "firstName");
  const lastNameValidation = validation.find((v) => v.field === "lastName");
  const { t } = useTranslation();

  return (
    <div>
      <TextField
        testId="first-name-input"
        error={!!firstNameValidation}
        errorMessage={firstNameValidation?.message}
        label={`${t("FIRSTNAME")}*`}
        value={user?.firstName ?? ""}
        sensitiveField={true}
        maxlength={100}
        onChange={onChangeUser("firstName")}
      />
      <TextField
        testId="last-name-input"
        error={!!lastNameValidation}
        errorMessage={lastNameValidation?.message}
        label={`${t("LASTNAME")}*`}
        value={user?.lastName ?? ""}
        sensitiveField={true}
        maxlength={100}
        onChange={onChangeUser("lastName")}
      />
    </div>
  );
};

export default EditableName;
